// extracted by mini-css-extract-plugin
export default {"firstDivider":"LayoutDivider_firstDivider__6Dt8D","secondDivider":"LayoutDivider_secondDivider__Xb9-2","thirdDivider":"LayoutDivider_thirdDivider__bG92D"};